import { INIT } from './view'

export const NAMESPACE = 'KanBo/Board/settings/'
export const SET = NAMESPACE + 'SET'

const defaultBoardState = {
  allowCardRemove: true,
  chat: true,
  lang: 'en-US',
  timeline: true,
  color: 0,
  cardTemplateId: null
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case SET:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          ...action.payload.settings,
        }
      } : state
    default: return state
  }
}

export function set ({ boardId, settings }) {
  return {
    type: SET,
    payload: {
      boardId,
      settings,
    }
  }
}
